const AuthorizationTypes = {
    none: 'No Authentication',
    basic: 'Basic Authentication',
    digest: 'Digest',
    oauth1: '0Auth 1.0',
};

export default AuthorizationTypes;

export const AuthorizationTypesList = Object
    .keys(AuthorizationTypes)
    .map(type => ({key: type, value: AuthorizationTypes[type]}));
